<template>
	<ModalFormCard class="modal-default" formCSS="bg-[#111111]">
		<template #title>Call with James Waring</template>

		<div
			v-if="$twilio.activeCall != null"
			class="h-[444px] flex flex-col items-center text-grey-900 text-15"
		>
			<p class="text-white text-28 font-hero font-bold mt-16">
				{{ $twilio.activeCall.name }}
			</p>
			<p class="mt-2">
				{{ $help.e164ToNumber($twilio.activeCall.from) }}
			</p>

			<p class="mt-10">{{ $help.fmtMSS($twilio.activeCall.duration) }}</p>
			<p class="mt-2">{{ $twilio.activeCall.status }}</p>

			<div class="flex items-center justify-center gap-4 mt-[120px]">
				<button
					class="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center"
				>
					<IconUser class="w-6 h-6 stroke-white" />
				</button>

				<button
					class="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center"
					@click="$twilio.toggleMute()"
				>
					<IconMute class="w-5 h-5 stroke-white" />
				</button>

				<button
					class="w-12 h-12 rounded-full bg-red-700 flex items-center justify-center"
					@click="$twilio.end()"
				>
					<IconDecline class="w-7 h-7 stroke-white" />
				</button>
			</div>
		</div>
	</ModalFormCard>
</template>

<script>
import Modal from "~/mixins/modal.js";

export default {
	mixins: [Modal],
};
</script>
